<template>
  <div class="st-file-upload">
    <div class="file-item" v-for="(v, i) in fileList" :key="i">
      <img class="icon-pdf" src="@/assets/svg/pdf.svg" alt="" />
      <div class="file-format">{{ fileFormats[v.url] ? fileFormats[v.url] : fileFormat }}</div>
      <i class="el-icon-close" @click="delItem(i)"></i>
      <div></div>
      <p style="max-width: 62px;overflow: hidden;word-wrap: break-word;text-align: center;">{{ v.name }}</p>
    </div>
    <el-upload
      :action="action"
      class="avatar-uploader st-form-item-input"
      :show-file-list="showFileList"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeUpload"
    >
			<input ref="urls" type="text" :name="name" style="opacity: 0;width: 0px;heigth: 0px;" v-model="urls">
      <i class="el-icon-circle-plus-outline"></i>
    </el-upload>
		
  </div>
</template>

<script>
import axios from 'axios';
export default {
  components: {},
  props: {
    value: {
      type: [Array],
      default: () => {
        return [];
      }
    },
    action: {
      type: String,
      default: () => {
        return '';
      }
    },
    showFileList: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
		name: {
		  type: String,
		  default: () => {
		    return '';
		  }
		},

  },
  data() {
    return {
      fileFormat: 'PDF',
      fileList: [],
			fileFormats: {},
			urls: '',
    };
  },
  watch: {
    value: {
      handler: function(newv, oldv) {
        // 当数据改变的时候 及时响应
        this.fileList = newv;
				this.urls = "";
				newv.forEach((item) => {
					this.fileFormats[item.url] = this.getFileExt(item.url).toUpperCase();
					this.urls += item.url;
				});
      },
      immediate: true,
      deep: true
    },
    fileList: {
      handler: function(newv, oldv) {
        // 当数据改变的时候 及时响应
        this.$emit('input', newv);
				newv.forEach((item) => {
					this.fileFormats[item.url] = this.getFileExt(item.url).toUpperCase();
				});
				this.emitInputBlur();
      },
      immediate: true,
      deep: true
    },
  },

  methods: {
    init() {},
		// 获取文件后缀
		getFileExt(url) {
			const fileExtension = url.split('.').pop();
			return fileExtension;
		},
    handleAvatarSuccess(res, file, fileList) {
    },
    beforeAvatarUpload() {
    },
    // 删除项
    delItem(ind) {
      this.fileList.splice(ind, 1);
			
    },
    beforeUpload(file) {
      this.uploadFile(file);
      return false;
    },
    // 上传文件
    async uploadFile(file) {
      let formData = new FormData();
      formData.append('file[]', file);
      formData.append('file_type_id', 1);
      formData.append('company_id', 0);
      formData.append('dangan', 0);
      formData.append('category_id', '');
      this.formData = formData;
      try {
        const response = await axios.post(this.$api.stUpload, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        let res = response.data;
        if (res.code !== 1) {
          this.$toast.fail('文件上传失败');
          return;
        }
        let fileRes = res.data;
        this.fileList.push(...fileRes.map((item) => { return { name: item.name, url: item.url } }));
      } catch (error) {
        console.error('上传失败:', error);
      }

    },
		
		// 触发input blur 事件
		emitInputBlur() {
		  this.$nextTick(() => {
		    let ele = this.$refs['urls'];
		    ele.focus();
		    ele.blur();
		  })
		},

  },
  created() {
    this.init();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.st-file-upload {
	overflow: hidden;
  /deep/ .el-upload--text {
    border: none;
    .el-icon-circle-plus-outline {
      font-size: 51px;
      color: rgb(153, 153, 153);
      padding: 12px 10px;
    }
  }

  .icon-pdf {
    height: 62px;
    width: 62px;
  }

  .file-item:last-child {
    margin-right: 0px;
  }

  .file-item {
    min-height: 130px; 
    float:left;
    position: relative;
    margin-right: 15px;
    line-height: 15px;
    
    
    .el-icon-close {
      position: absolute;
      font-size: 18px;
      font-weight: 900;
      color: red;
      transform: translate(-14px, 0px);
    }

    .file-format {
      position: absolute;
      transform: translate(16px,-32px);
      float: left;
      color: white;
      font-weight: 400;
    }
  }

}
</style>
